module.exports = __webpack_public_path__ + "static/media/bdb-entreview-ico-gray.4c59ace2.svg";